import { FormControl } from "react-bootstrap";
import { useCallback, useState } from "react";
import { BinIcon } from "../Icon/Icon";

export default function FormPasswordEye(props) {
    const {
        disabled,
        isInvalid,
        iconColor = 'var(--color-primary)',
        iconDisabledColor = 'var(--color-secondary)',
        ...otherProps
    } = props;
    const [show, setShow] = useState();
    const clickHandler = useCallback(() => setShow(!show), [show]);

    return <div style={{ position: 'relative' }} className={isInvalid ? 'is-invalid' : ''}>
        <FormControl type={show ? 'text' : 'password'} disable={disabled} isInvalid={isInvalid} {...otherProps} style={{
            paddingRight: '3rem'
        }}/>
        <BinIcon style={{
            position: 'absolute',
            right: 0,
            top: 0,
            margin: '0.75rem 1rem',
            fill: disabled ? iconDisabledColor : iconColor,
        }} name={show ? 'IcEyeOn' : 'IcEyeOff'} onClick={clickHandler}/>
    </div>
}
